<template>
  <template
    v-for="(modeGroup, modeGroupIndex) in MODE_GROUPS"
    :key="modeGroup.groupTitle"
  >
    <h4 class="mode-button-group-label tablet-hidden" :class="{ 'mode-button-group-label-first': modeGroupIndex === 0 }">{{ modeGroup.groupTitle }}</h4>
    <div
      v-for="(mode, modeIndex) in modeGroup.modes"
      :key="mode.id"
      class="mode-button-container"
      :class="{ 'first-mode-button-container': modeIndex === 0 }"
    >
      <button
        type="button"
        @click="setMode(mode)"
        class="mode-button"
        :class="{ 'active-button': currentModeId === mode.id }"
        :disabled="mode.isUnavailableForInvalidSymbols && isSymbolBeingViewedNotFound"
      >
        <i :class="mode.icon"></i>
        &nbsp;{{ mode.title }}
      </button>
    </div>
  </template>
</template>

<script lang="ts" setup>
  import { watch } from 'vue';
  import { useModes } from '@/composables/useModes';
  import { useSymbolInformation } from '@/composables/useSymbolInformation';

  const { MODE_GROUPS, CHART_SETTINGS_MODE, currentModeId, currentMode, setMode } = useModes();
  const { isSymbolBeingViewedNotFound } = useSymbolInformation();

  watch(isSymbolBeingViewedNotFound, (newIsSymbolNotFoundValue) => {
    if (newIsSymbolNotFoundValue && currentMode.value?.isUnavailableForInvalidSymbols) {
      setMode(CHART_SETTINGS_MODE);
    }
  });
</script>

<style scoped>
  .mode-button-group-label {
    border-bottom: 2px solid #c0ced8;
    text-transform: uppercase;
    font-family: 'Roboto Condensed', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: bold;
    color: #707f8f;
    margin: 16px 6px 2px 6px;
    padding: 0px;
    width: calc(100% - 12px);
    text-align: left;
  }

  .mode-button-group-label-first {
    margin-top: 0px;
  }

  .mode-button-container {
    font-size: 0px;
    margin: 4px 6px;
    width: calc(100% - 12px);
    height: 30px;
  }

  .mode-button-container.first-mode-button-container {
    margin-top: 0px;
  }

  button.mode-button {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin: 0px;
    padding: 0px 0px 0px 6px;
    width: 100%;
    height: 100%;
    font-size: 14px;
    font-weight: 700;
    border: 1px solid transparent;
    background-color: transparent;
    border-radius: 3px;
    color: black;
    text-align: left;
  }

  button.mode-button:hover {
    background-color: #dfe7ec;
    border-color: #c0ced8;
    color: #2d3339;
  }

  button.mode-button.active-button,
  button.mode-button.active-button:hover {
    background-color: #3281d0;
    border-color: #3281d0;
    color: white;
  }

  button.mode-button:disabled {
    opacity: 0.5 !important;
  }
</style>
